"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OffersNotFound = require("./OffersNotFound");
Object.keys(_OffersNotFound).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OffersNotFound[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OffersNotFound[key];
    }
  });
});